import React, {useEffect} from 'react';
import Footer from './footer';
import Header from './header';
import HeaderNew from "./header-new";


const Layout = ( {children, page, heroTitle, heroContent, heroCTA, heroImage, headCall, video, vimeo, nav, value, hvec, videoText, footer} ) => {

    useEffect(() => {
        // window.scrollTo(0, 0)
        document.body.classList.remove('modal-open');
      }, [])


    return (
        <>
            {page === "home" ? <HeaderNew nav={nav} page={page} heroTitle={heroTitle} heroContent={heroContent} heroImage={heroImage} heroCTA={heroCTA} video={video} videoText={videoText} vimeo={vimeo} hvec={hvec} headCall={headCall} value={value} /> : <Header nav={nav} headCall={headCall} />}
            {children}
            <Footer nav={nav} foot={footer} />
        </>
    );
}

export default Layout;
